import { render, staticRenderFns } from "./ContractInfoStorageProvider.vue?vue&type=template&id=0a10617a"
import script from "./ContractInfoStorageProvider.vue?vue&type=script&lang=js"
export * from "./ContractInfoStorageProvider.vue?vue&type=script&lang=js"
import style0 from "./ContractInfoStorageProvider.vue?vue&type=style&index=0&id=0a10617a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports